import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getServiceSideCostPayments = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/service_side_cost_settlement`
    );
  }
  return http.get(
    `${getBaseUrl()}/service_side_cost_settlement?${paginate}`
  );
};

export const updateServiceSideCostPayment = data => {
  return http.put(
    `${getBaseUrl()}/service_side_cost_settlement/${data.id}`,
  );
};


export const updateCancelServiceSideCostPayment = data => {
  return http.put(
    `${getBaseUrl()}/cancel_service_side_cost_settlement/${data.id}`,
  );
};

